// extracted by mini-css-extract-plugin
export var header = "index-module--header--+tJQO";
export var top = "index-module--top--Gpswn";
export var bottom = "index-module--bottom--Nv+8e";
export var slideDown = "index-module--slideDown--zViMN";
export var logo = "index-module--logo--nlzXC";
export var search = "index-module--search--nCnPB";
export var fadein = "index-module--fadein--5D3+G";